export default {
  path: '/toBeVIP',
  name: 'toBeVip',
  component: () => import('@/views/User/toBeVip.vue')
}



// WEBPACK FOOTER //
// ./src/router/modules/tbBeVip.js